import React from 'react';
import PropTypes from 'prop-types';

import AbsoluteAsset from '../AbsoluteAsset';
import AbsoluteGear from '../AbsoluteGear';

import './about.scss';

const About = props => (
  <div className="abs-asset-holder">
    <div className="anchor" id="About" />
    <div className="container">
      <div className="about__row">
        <div className="about__text youtube-margin">
          {props.children}
        </div>
        <div className="about__video-wrapper">
          <div className="about__video">
            <iframe
              title="Hack the North 2018"
              src="https://www.youtube-nocookie.com/embed/P3VhS7jvXN8?rel=0&amp;showinfo=0"
              frameBorder="0"
              allowFullScreen
            />
          </div>
          <p className="about__video__subtext">Watch the recap video</p>
        </div>
      </div>
    </div>
    <AbsoluteAsset alt="Conveyer Illustration" src="/images/conveyer.png" className="conveyer" />
    <AbsoluteAsset alt="Conveyer Illustration" src="/images/robot.png" className="robot" />
    <AbsoluteAsset className="e52 e52--about" src="/assets/e52.png" />
    <AbsoluteAsset className="e53 e53--about" src="/assets/e53.png" />
    <AbsoluteGear className="gear--yellow1" speed={10} src="/images/yellow1.png" />
    <AbsoluteGear className="gear--blue1" speed={-10} src="/images/blue1.png" />
    <AbsoluteGear className="gear--red1" speed={-10} src="/images/red1.png" />
  </div>
);

About.propTypes = {
  children: PropTypes.node.isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.jsx